// Only bridges in-app account verification. Never persist this object.
const handoff = {
    answers: null, completed: [], signatures: null, signedOutput: false, pendingSave: false,
};
export const clearPoahcHandoff = () => {
    Object.assign(handoff, {
        answers: null, completed: [], signatures: null, signedOutput: false, pendingSave: false,
    });
};
export default handoff;
